<div class="w-full h-full">
  <fun-spinner *ngIf="loading"></fun-spinner>
  <fun-overal-message *ngIf="!loading" [text]="textHubs" [image]="imageHubs" [btnList]="btnList" (btnEvent)="clickBtn($event)"></fun-overal-message>
</div>